import React, { Fragment } from 'react'
import BlogCategorySlice from './slices/BlogCategorySlice'
import BrandAssetsSlice from './slices/BrandAssetsSlice'
import CareersSlice from './slices/CareersSlice'
import ComponentSectionSlice from './slices/ComponentSectionSlice'
import ContactSlice from './slices/ContactSlice'
import CTASlice from './slices/CTASlice'
import DepositAndWithdrawSlice from './slices/DepositAndWithdrawSlice'
import DocsTabsSlice from './slices/DocsTabsSlice'
import DownloadPlatformsSlice from './slices/DownloadPlatformsSlice'
import FollowUsSlice from './slices/FollowUsSlice'
import FormulaTabsSlice from './slices/FormulaTabsSlice'
import HeroBannerSlice from './slices/HeroBannerSlice'
import IconsGridSlice from './slices/IconsGridSlice'
import IFrameSlice from './slices/IFrameSlice'
import LeverageTabsSlice from './slices/LeverageSlice'
import LogosBannerSlice from './slices/LogosBannerSlice'
import MarketNewsSlice from './slices/MarketNewsSlice'
import MobileAppSectionSlice from './slices/MobileAppSectionSlice'
import NumberedListSlice from './slices/NumberedListSlice'
import OurPhilosophySlice from './slices/OurPhilosophySlice'
import PillarsSlice from './slices/PillarsSlice'
import PresenterSlice from './slices/PresenterSlice'
import PricingTabsSlice from './slices/PricingTabsSlice'
import ProductTabsSlice from './slices/ProductTabsSlice'
import PromotionsSlice from './slices/PromotionsSlice'
import ReasonsWhySlice from './slices/ReasonsWhySlice'
import ScriptSlice from './slices/ScriptSlice'
import ServingYourTechSlice from './slices/ServingYourTechSlice'
import SpacerSlice from './slices/SpacerSlice'
import TableTabsSlice from './slices/TableTabsSlice'
import TabsBannerSlice from './slices/TabsBannerSlice'
import TabsSlice from './slices/TabsSlice'
import TextSlice from './slices/TextSlice'
import TradingEnvSlice from './slices/TradingEnvSlice'
import TradingToolsSlice from './slices/TradingToolsSlice'
import WebinarsSlice from './slices/WebinarsSlice'
import YourFundsSlice from './slices/YourFundsSlice'
import YourWindowGlobalSlice from './slices/YourWindowGlobalSlice'

export type Slice =
  | GatsbyTypes.PrismicHomepageBodyServingYouTechFragment
  | GatsbyTypes.PrismicHomepageBodyYourFundsFragment
  | GatsbyTypes.PrismicHomepageBodyTradingToolsFragment
  | GatsbyTypes.PrismicPageBodyNumberedListFragment
  | GatsbyTypes.PrismicPageBodyTabsFragment
  | GatsbyTypes.PrismicPageBodyLogosBannerFragment
  | GatsbyTypes.PrismicPageBodyCallToActionFragment
  | GatsbyTypes.PrismicPageBodyDownloadPlatformsFragment
  | GatsbyTypes.PrismicPageBodyReasonsWhyFragment
  | GatsbyTypes.PrismicPageBodyHeroBannerFragment
  | GatsbyTypes.PrismicPageBodyDownloadPlatformsFragment
  | GatsbyTypes.PrismicHomepageBodyTabsBannerFragment
  | GatsbyTypes.PrismicHomepageBodyDepositAndWithdrawFragment
  | GatsbyTypes.PrismicHomepageBodyYourWindowGlobalFragment
  | GatsbyTypes.PrismicHomepageBodyMobileAppSectionFragment
  | GatsbyTypes.PrismicHomepageBodyMarketNewsFragment
  | GatsbyTypes.PrismicPageBodyComponentSectionFragment
  | GatsbyTypes.PrismicPageBodySpacerFragment
  | GatsbyTypes.PrismicPageBodyIconsGridFragment
  | GatsbyTypes.PrismicPageBodyContactFragment
  | GatsbyTypes.PrismicPageBodyProductTabsFragment
  | GatsbyTypes.PrismicPageBodyFormulaTabsFragment
  | GatsbyTypes.PrismicPageBodyTextFragment
  | GatsbyTypes.PrismicPageBodyTableTabsFragment
  | GatsbyTypes.PrismicPageBodyPricingTabsFragment
  | GatsbyTypes.PrismicPageBodyDocsTabsFragment
  | GatsbyTypes.PrismicPageBodyCareersFragment
  | GatsbyTypes.PrismicPageBodyPromotionsFragment
  | GatsbyTypes.PrismicPageBodyBrandAssetsFragment
  | GatsbyTypes.PrismicPageBodyFollowUsFragment
  | GatsbyTypes.PrismicPageBodyBlogCategoryFragment
  | GatsbyTypes.PrismicPageBodyIframeFragment
  | GatsbyTypes.PrismicPageBodyWebinarsFragment
  | GatsbyTypes.PrismicPageBodyPresenterFragment
  | GatsbyTypes.PrismicPageBodyScriptFragment
  | GatsbyTypes.PrismicPageBodyPillarsFragment
  | GatsbyTypes.PrismicPageBodyTradingEnvFragment
  | GatsbyTypes.PrismicPageBodyLeverageTabsFragment

export type SliceComponentProps = {
  slice: Slice
}

export type SliceComponent = React.FC<SliceComponentProps>

export interface SliceZoneProps {
  slices: GatsbyTypes.Maybe<ReadonlyArray<GatsbyTypes.Maybe<Slice>>>
}

const sliceComponents: Record<string, SliceComponent> = {
  serving_you_tech: ServingYourTechSlice,
  your_funds: YourFundsSlice,
  numbered_list: NumberedListSlice,
  tabs: TabsSlice,
  logos_banner: LogosBannerSlice,
  call_to_action: CTASlice,
  trading_tools: TradingToolsSlice,
  tabs_banner: TabsBannerSlice,
  deposit_and_withdraw: DepositAndWithdrawSlice,
  your_window_global: YourWindowGlobalSlice,
  mobile_app_section: MobileAppSectionSlice,
  reasons_why: ReasonsWhySlice,
  hero_banner: HeroBannerSlice,
  download_platforms: DownloadPlatformsSlice,
  component_section: ComponentSectionSlice,
  spacer: SpacerSlice,
  icons_grid: IconsGridSlice,
  contact: ContactSlice,
  product_tabs: ProductTabsSlice,
  formula_tabs: FormulaTabsSlice,
  text: TextSlice,
  table_tabs: TableTabsSlice,
  pricing_tabs: PricingTabsSlice,
  docs_tabs: DocsTabsSlice,
  careers: CareersSlice,
  promotions: PromotionsSlice,
  brand_assets: BrandAssetsSlice,
  follow_us: FollowUsSlice,
  blog_category: BlogCategorySlice,
  iframe: IFrameSlice,
  webinars: WebinarsSlice,
  presenter: PresenterSlice,
  script: ScriptSlice,
  pillars: PillarsSlice,
  trading_env: TradingEnvSlice,
  our_philosophy: OurPhilosophySlice,
  market_news: MarketNewsSlice,
  leverage_tabs: LeverageTabsSlice
} as Record<string, SliceComponent>

const SliceZone: React.FC<SliceZoneProps> = ({ slices }) => (
  <Fragment>
    {slices?.map((slice) => {
      if (!slice?.slice_type) {
        return null
      }

      const Component = sliceComponents[slice.slice_type]

      if (!Component) {
        return null
      }

      return <Component slice={slice} key={slice.id} />
    })}
  </Fragment>
)

export default SliceZone
